var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module--dashboard_dash_block"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("head"),_c('div',{staticClass:"content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }